const PREFIX = "weld";
const SEPARATOR = ":";

export function createKeyCreator(namespace?: string) {
  return (...tokens: string[]) => {
    return [PREFIX, namespace, ...tokens].filter(Boolean).join(SEPARATOR);
  };
}

export const createStorageKey = createKeyCreator();

function getSafeLocalStorageKeys(): string[] {
  try {
    return Object.keys(window.localStorage);
  } catch {
    return [];
  }
}

export function removeStorageItems(predicates: ((key: string) => boolean)[]) {
  const storageKeys = getSafeLocalStorageKeys();
  storageKeys.forEach((storageKey) => {
    const shouldRemove = predicates.some((fn) => fn(storageKey));
    if (shouldRemove) {
      try {
        window.localStorage.removeItem(storageKey);
      } catch {
        // fail silently
      }
    }
  });
}
